const tenantIds = {
  sbnation: "af45136e-0aa2-4340-8ea6-e1f0416340f5",
  theverge: "107892e5-bd39-4cf4-8acd-ff9dad7aa878",
  eater: "4fbf330f-aaee-427f-9959-c10d08a6ed2c",
};

export const EATER_TENANT_ID = tenantIds.eater;

const networkToTenantId = new Map<string, string>();
networkToTenantId.set("sbnation.com", tenantIds.sbnation);
networkToTenantId.set("theverge.com", tenantIds.theverge);
networkToTenantId.set("eater.com", tenantIds.eater);

export const getTenantIdFromNetwork = (network: string): string | null => {
  return networkToTenantId.get(network) ?? null;
};
